import React, { useEffect, useState } from 'react'
import { useLocation, Redirect } from 'react-router-dom'

const isMobileDevice = (): boolean => {
  const userAgent =
    navigator.userAgent || navigator.vendor || (window as any).opera
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    userAgent.toLowerCase()
  )
}

const MagicLinkRoute: React.FC = () => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const [shouldRedirect, setShouldRedirect] = useState(false)

  const hasToken = searchParams.has('token')
  const hasCode = searchParams.has('code')
  const hasMagicLinkParams = hasToken || hasCode

  useEffect(() => {
    if (!hasMagicLinkParams) {
      // No magic link params, redirect to landing immediately
      setShouldRedirect(true)
      return
    }

    if (!isMobileDevice()) {
      // Desktop: redirect to login-app immediately
      setShouldRedirect(true)
      return
    }

    // Mobile: Wait for deep link to open app, then show fallback
    // The OS will attempt to open the app via universal/deep link
    // If the app doesn't open within the timeout, show the fallback page
    const timeout = setTimeout(() => {
      setShouldRedirect(true)
    }, 2000)

    return () => clearTimeout(timeout)
  }, [hasMagicLinkParams])

  if (shouldRedirect) {
    if (hasMagicLinkParams) {
      return <Redirect to="/login-app" />
    }
    return <Redirect to="/landing" />
  }

  // Mobile: Show loading state while waiting for app to open
  return null
}

export default MagicLinkRoute
